var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useImperativeHandle, useRef } from 'react';
import { mergeProps, useFocusRing } from 'react-aria';
import { useId } from '../hooks';
import CharacterCount from './character-count';
import { textAreaStyle, textAreaWrapperStyle } from './styles';
function TextAreaInternal(_a, ref) {
    var { autoGrow = false, counterAriaLabel, error = false, inverted = false, maxLength, showCharacterCount, size = 'medium', value } = _a, restProps = __rest(_a, ["autoGrow", "counterAriaLabel", "error", "inverted", "maxLength", "showCharacterCount", "size", "value"]);
    const { focusProps, isFocusVisible } = useFocusRing();
    const characterCounterId = `character-count-${useId()}`;
    const textAreaRef = useRef(null);
    useImperativeHandle(ref, () => textAreaRef.current);
    function handleInput() {
        if (textAreaRef.current != null) {
            textAreaRef.current.style.height = 'auto';
            textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
        }
    }
    return (_jsxs("div", Object.assign({ css: textAreaWrapperStyle({ inverted, isFocusVisible }) }, { children: [_jsx("textarea", Object.assign({}, (showCharacterCount && {
                'aria-describedby': characterCounterId,
            }), { "aria-invalid": error, css: textAreaStyle({ hasError: !!error, size }), maxLength: maxLength, ref: textAreaRef }, mergeProps(focusProps, restProps, Object.assign({}, (autoGrow && { onInput: handleInput }))), { value: value })), showCharacterCount && maxLength != null && (_jsx(CharacterCount, Object.assign({ id: characterCounterId, limit: maxLength }, { counterAriaLabel, size, value })))] })));
}
export default TextAreaInternal;
